import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const UpdateInvoiceLineItemMutation = graphql.persisted(
  "UpdateInvoiceLineItem",
  graphql(`
    mutation UpdateInvoiceLineItem($input: UpdateInvoiceLineItemInput!) {
      updateInvoiceLineItem(input: $input) {
        lineItem { id description amountCents lineType }
        userErrors { message path }
      }
    }
  `)
);

export { UpdateInvoiceLineItemMutation };

export function useUpdateInvoiceLineItem() {
  return useMutation(UpdateInvoiceLineItemMutation);
}
